<ng-container *ngIf="sensorName == '' else assetDetails">
	<span>No Asset Selected</span>
</ng-container>
<ng-template #noAsset></ng-template>
<ng-template #assetDetails>
	<!-- Show the Event Info for the Asset -->
	<ng-container *ngIf="fromEvent then AssetEventInfo"></ng-container>
	<!-- Show the actual Graph Component -->
	<ng-container *ngIf="(correctLocation || fromEvent) then appAssetChart"></ng-container>
</ng-template>


<ng-template #AssetEventInfo>
	<div class="event-asset" *ngIf="fromEvent">
		<div *ngIf="selectedAsset" class="event-asset-details">
			<span>Name:</span>
			<span>{{selectedAsset.Name}}</span>
			<span>Description:</span>
			<span>{{selectedAsset.Description}}</span>
			<span>AssetID:</span>
			<span>{{selectedAsset.AssetID}}</span>
			<span *ngIf="timeFrom && timeTo">Event Trigger Window: </span>
			<span *ngIf="timeFrom && timeTo" style="font-weight: bolder;">{{ getReadableTime(timeFrom) }} - {{
				getReadableTime(timeTo) }}</span>
		</div>
		<span class="toolbar-spacer"></span>
		<div class="event-asset-buttons">
			<button *ngIf="selectedAsset" mat-raised-button color="primary" class="app-icon--goto"
				(click)="goToFunctionalLocation(this.selectedAsset.AssetID)"
				title="View on the Function Locations page">
				<span>Go To Asset</span>
				<mat-icon />
			</button>
			<button *ngIf="selectedAsset" mat-raised-button color="" (click)="goBack()" class="app-icon--back">
				<span>Back</span>
				<mat-icon />
			</button>
			<button *ngIf="selectedAsset" mat-raised-button color="primary" routerLink="/event" class="app-icon--goto">
				<span>Events</span>
				<mat-icon />
			</button>
		</div>
	</div>
</ng-template>

<ng-template #AssetButtons>
	<div class="asset-detail-buttons">
		<button class="alignRow" mat-raised-button (click)="popUpDatapoints()">
			<span>DataPoints</span>
			<mat-icon>sensors</mat-icon>
		</button>
		<button class="alignRow" mat-raised-button
			(click)="popUpRules()"><mat-icon>rule</mat-icon><span>Rules</span></button>
		<button class="alignRow" mat-raised-button (click)="createAction()">
			<span>Create Action</span>
			<mat-icon>content_paste</mat-icon>
		</button>
		<button class="alignRow" mat-raised-button
			(click)="openAssetModels()"><mat-icon>auto_awesome</mat-icon><span>Asset Models</span></button>
		<button class="alignRow" mat-raised-button color="primary" (click)="compareAsset()">
			<span>Compare Asset</span>
			<mat-icon>stacked_line_chart</mat-icon>
		</button>
		<button class="alignRow" *ngIf="selectedAsset && selectedAsset.Watch"
			style="background-color: var(--watch-bg-color);" mat-raised-button (click)="popUpWatchList()">
			<span>Watch List Info</span>
			<mat-icon>visibility_on</mat-icon>
		</button>
		<button class="alignRow" *ngIf="selectedAsset && selectedAsset.Actioned"
			style="background-color: var(--action-bg-color);" mat-raised-button (click)="popUpActionList()">
			<span>Actions</span>
			<mat-icon>content_paste</mat-icon>
		</button>
		<span class="toolbar-spacer"></span>
		<button class="alignRow" *ngIf="selectedAsset" mat-raised-button
			(click)="popUpHistory()"><mat-icon>history</mat-icon>
			<span>Event & Action History</span>
		</button>
	</div>
</ng-template>

<ng-template #appAssetChart>
	<app-asset-charts *ngIf="selectedAsset" assetID="{{selectedAsset.AssetID}}"
		selectedOrganisationUID="{{selectedOrganisationUID}}"></app-asset-charts>
</ng-template>